var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2124 14.4934C12.0791 14.48 11.9191 14.48 11.7724 14.4934C8.5991 14.3867 6.0791 11.7867 6.0791 8.58669C6.0791 5.32002 8.7191 2.66669 11.9991 2.66669C15.2658 2.66669 17.9191 5.32002 17.9191 8.58669C17.9058 11.7867 15.3858 14.3867 12.2124 14.4934Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8804 5.33331C24.467 5.33331 26.547 7.42665 26.547 9.99998C26.547 12.52 24.547 14.5733 22.0537 14.6666C21.947 14.6533 21.827 14.6533 21.707 14.6666",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54598 19.4133C2.31931 21.5733 2.31931 25.0933 5.54598 27.24C9.21264 29.6933 15.226 29.6933 18.8926 27.24C22.1193 25.08 22.1193 21.56 18.8926 19.4133C15.2393 16.9733 9.22598 16.9733 5.54598 19.4133Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4531 26.6667C25.4131 26.4667 26.3198 26.08 27.0665 25.5067C29.1465 23.9467 29.1465 21.3734 27.0665 19.8134C26.3331 19.2534 25.4398 18.88 24.4931 18.6667",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/Client.cc75ac6b509beb0eaf044748b93f8eec.svg";
export { ForwardRef as ReactComponent };